import { useQuery } from '@tanstack/react-query';

import { apiCall, apiClient } from 'shared/client/apiClient';
import { LearningObjectDraft } from 'shared/types/LearningObjects';
import { useWorkMode } from 'shared/utils/useWorkMode';

export const getPlenaryDraftById = async (plenaryDraftId: string, includeDeleted?: boolean) => {
  // `apiCall` so a refusal throws with its status — a 404 must reach the route loader as not-found rather than
  // resolve as `undefined` data.
  const data = await apiCall(
    apiClient.GET('/plenary-drafts/{plenaryDraftId}', {
      params: { path: { plenaryDraftId }, query: { ...(includeDeleted && { includeDeleted: 'true' }) } }
    })
  );
  return data as LearningObjectDraft; //FIXME provide return type
};

export const plenaryDraftByIdQueryKey = ({ plenaryDraftId }: { plenaryDraftId?: string }) =>
  ['plenary-draft', { plenaryDraftId }] as const;

export const useGetPlenaryDraftByIdQuery = (plenaryDraftId?: string) => {
  const { isPlayerAssignment } = useWorkMode();

  return useQuery({
    queryKey: plenaryDraftByIdQueryKey({ plenaryDraftId }),
    queryFn: () => getPlenaryDraftById(plenaryDraftId as string, isPlayerAssignment),
    enabled: !!plenaryDraftId
  });
};
